module.exports = __webpack_public_path__ + "img/branchtoteller.fw.61ae9b8b.png";